/**
 * Currency formatter utility for consistent money formatting across the app
 * Formats amounts in the "₱X,XXX.XX" format
 */

export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '₱0.00';
  
  // Convert to number if it's a string
  const num = typeof amount === 'string' ? parseFloat(amount.replace(/[^0-9.-]+/g, '')) : Number(amount);
  
  // Handle NaN or invalid numbers
  if (isNaN(num)) return '₱0.00';
  
  // Format with commas and 2 decimal places, explicitly using peso symbol
  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'decimal' // Explicitly use decimal style to avoid currency symbol
  });
  
  return `₱${formatted}`;
};

export const formatCurrencyCompact = (amount) => {
  if (!amount && amount !== 0) return '₱0';
  
  const num = typeof amount === 'string' ? parseFloat(amount.replace(/[^0-9.-]+/g, '')) : Number(amount);
  
  if (isNaN(num)) return '₱0';
  
  // For compact display (no decimal places), explicitly using peso symbol
  const formatted = num.toLocaleString('en-US', {
    style: 'decimal' // Explicitly use decimal style to avoid currency symbol
  });
  
  return `₱${formatted}`;
}; 